import { Trans } from '@lingui/react'

import type { Article, ArticleHeadlineComponent } from '@twisto/api-cms'
import { Link } from '@twisto/components/atoms/link'
import { Typography } from '@twisto/components/atoms/typography'

import { createIdFromSlugAndId } from 'homepage/utils'

import * as styles from './table-of-content.styles'

type Props = {
  article: Article
}

const isArticleHeadlineComponent = (
  component: unknown
): component is ArticleHeadlineComponent =>
  typeof component === 'object' &&
  component !== null &&
  (component as ArticleHeadlineComponent).__component === 'article.headline'

export const TableOfContent = ({ article }: Props) => {
  const headlines = article.contentSections.filter(isArticleHeadlineComponent)

  if (headlines.length === 0) {
    return null
  }

  return (
    <nav>
      <Typography
        color="textSecondary"
        css={styles.tableOfContentLabel}
        variant="b2"
      >
        <Trans id="article.tableOfContent.label" />
      </Typography>
      <ul css={styles.tableOfContentList}>
        {headlines.map(({ name, id, tag }) => (
          <li
            key={id}
            css={[
              styles.tableOfContentListItem,
              tag !== 'h2' && styles.tableOfContentListItemPadded,
            ]}
          >
            <Typography variant="b2">
              <Link href={`#${createIdFromSlugAndId(name, id)}`}>{name}</Link>
            </Typography>
          </li>
        ))}
      </ul>
    </nav>
  )
}
